module.exports = __webpack_public_path__ + "img/grace-pro.5e037ff9.jpg";